import * as React from 'react';
import { TButtonSize } from '@cian/ui-kit/button/types';
import { useSelector } from 'react-redux';

import { selectConsultantMessageButtonAvailable } from '../../selectors/consultantChat';
import { BuilderChatButtonContainer } from '../BuilderChatButton';
import { ConsultantChatButtonContainer } from '../ConsultantChatButton';

interface IMessageButtonContainerProps {
  isHeaderButton?: boolean;
  buttonSize?: TButtonSize;
}

export const MessageButtonContainer: React.FC<IMessageButtonContainerProps> = props => {
  const isConsultantMessageButtonAvailable = useSelector(selectConsultantMessageButtonAvailable);

  // TODO: Удалить в CD-225148, если эксперимент неудачен.
  if (isConsultantMessageButtonAvailable) {
    return <ConsultantChatButtonContainer {...props} />;
  }

  return <BuilderChatButtonContainer {...props} />;
};
